// import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
// import PlaceholderImage from '@/assets/images/placeholder.svg';

// interface ProductPreviewModalProps {
//   open: boolean;
//   imageUrl: string;
//   onClose: () => void;
// }

// export default function ProductPreviewModal({ open, imageUrl, onClose }: ProductPreviewModalProps) {
//   return (
//     <AlertDialogPrimitive.Root open={open}>
//       <AlertDialogPrimitive.Portal>
//         <AlertDialogPrimitive.Overlay className="fixed inset-0 z-51 bg-black/70 backdrop-blur-[2px]" />

//         <AlertDialogPrimitive.Content
//           onEscapeKeyDown={(event) => {
//             event.preventDefault();
//             onClose();
//           }}
//           className="fixed left-1/2 top-1/2 z-[51] flex min-h-[50vh] min-w-[60vw] -translate-x-1/2 -translate-y-1/2 items-center justify-center bg-background p-[12px] outline-none sm:min-h-[60vh] sm:min-w-[60vw] sm:p-[30px]"
//         >
//           <AlertDialogPrimitive.Title className="sr-only">Product image preview</AlertDialogPrimitive.Title>

//           <AlertDialogPrimitive.Description className="sr-only">
//             Preview of the selected product image.
//           </AlertDialogPrimitive.Description>

//           {/* Image */}
//           <img
//             className="block h-auto w-auto max-h-[calc(100vh-120px)] max-w-[calc(100vw-62px)] object-contain sm:max-h-[calc(100vh-200px)] sm:max-w-[calc(100vw-60px)]"
//             loading="eager"
//             onError={(event) => {
//               event.currentTarget.onerror = null;
//               event.currentTarget.src = PlaceholderImage;
//             }}
//             src={imageUrl || PlaceholderImage}
//             alt="product preview"
//           />

//           {/* Close button */}
//           <div className="absolute -right-[12px] top-[-44px] z-[52] flex items-center justify-end">
//             <button
//               type="button"
//               className="flex cursor-pointer flex-row items-center justify-center p-10 text-[clamp(17px,1.5vw,18px)] text-white"
//               onClick={onClose}
//             >
//               <span>CLOSE</span>
//               <span className="ml-2">X</span>
//             </button>
//           </div>
//         </AlertDialogPrimitive.Content>
//       </AlertDialogPrimitive.Portal>
//     </AlertDialogPrimitive.Root>
//   );
// }

import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import PlaceholderImage from '@/assets/images/placeholder.svg';

interface ProductPreviewModalProps {
  open: boolean;
  imageUrl: string;
  onClose: () => void;
}

export default function ProductPreviewModal({ open, imageUrl, onClose }: ProductPreviewModalProps) {
  return (
    <AlertDialogPrimitive.Root open={open}>
      <AlertDialogPrimitive.Portal>
        <AlertDialogPrimitive.Overlay className="fixed inset-0 z-51 bg-black/70 backdrop-blur-[2px]" />

        <AlertDialogPrimitive.Content
          onEscapeKeyDown={(event) => {
            event.preventDefault();
            onClose();
          }}
          className="
            fixed left-1/2 top-1/2 z-[51]
            flex
            max-h-[calc(100dvh-32px)]
            max-w-[calc(100vw-24px)]
            -translate-x-1/2
            -translate-y-1/2
            items-center
            justify-center
            bg-background
            p-3
            outline-none

            sm:max-h-[calc(100dvh-60px)]
            sm:max-w-[calc(100vw-60px)]
            sm:p-[30px]
          "
        >
          <AlertDialogPrimitive.Title className="sr-only">Product image preview</AlertDialogPrimitive.Title>

          <AlertDialogPrimitive.Description className="sr-only">
            Preview of the selected product image.
          </AlertDialogPrimitive.Description>

          {/* Image */}
          <img
            className="
              block
              max-h-[calc(100dvh-100px)]
              max-w-[calc(100vw-48px)]
              object-contain

              sm:max-h-[calc(100dvh-200px)]
              sm:max-w-[calc(100vw-160px)]
            "
            loading="eager"
            onError={(event) => {
              event.currentTarget.onerror = null;
              event.currentTarget.src = PlaceholderImage;
            }}
            src={imageUrl || PlaceholderImage}
            alt="product preview"
          />

          {/* Close button */}
          <div className="absolute -right-[12px] top-[-44px] z-[52] flex items-center justify-end">
            <button
              type="button"
              className="flex cursor-pointer flex-row items-center justify-center p-10 text-[clamp(17px,1.5vw,18px)] text-white"
              onClick={onClose}
            >
              <span>CLOSE</span>
              <span className="ml-2">X</span>
            </button>
          </div>
        </AlertDialogPrimitive.Content>
      </AlertDialogPrimitive.Portal>
    </AlertDialogPrimitive.Root>
  );
}
